import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class FormPostprocessorsService {
  constructor(private http: HttpClient) {}

  public fetchFormPostprocessors(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/postprocessor/list`
    return this.http.post(url, params)
  }
  public fetchFormPostprocessor(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/postprocessor/${id}`
    return this.http.get(url, {})
  }

  public deleteFormPostprocessor(id: number): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/postprocessor/${id}`
    return this.http.delete(url)
  }

  public createFormPostprocessor(params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/postprocessor`
    return this.http.post(url, params)
  }

  public updateFormPostprocessor(id: number, params: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/postprocessor/${id}`
    return this.http.put(url, params)
  }
}
